<template>
  <div>
    <Nav />
    <!-- 主要内容区 -->
    <div class="flex pt-20 max-w-7xl mx-auto">
      <LeftNav activeItem="index" />
      <main class="flex-1 p-6">
        <div class="">
          <div class="mb-8">
            <h1 class="text-2xl font-bold text-gray-900">个人资料</h1>
            <p class="text-gray-600 mt-1">管理您的账户信息</p>
          </div>
          <div class="bg-white rounded-xl shadow-sm p-8">
            <div class="grid grid-cols-12 gap-8 mb-8">
              <!-- 左侧头像列 -->
              <div class="col-span-3 flex justify-center">
                <div class="relative group">
                  <div
                    class="w-32 h-32 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden"
                  >
                    <img
                      :src="
                        userInfo.avatar ||
                        'https://readdy.ai/api/search-image?query=Professional%20asian%20businessman%20portrait%2C%20confident%20smile%2C%20modern%20office%20background%2C%20high-quality%20corporate%20headshot&width=96&height=96&seq=avatar&orientation=squarish'
                      "
                      alt="用户头像"
                      class="w-full h-full object-cover"
                    />
                  </div>
                  <button
                    class="absolute inset-0 bg-black bg-opacity-40 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                  >
                    <div class="w-8 h-8 flex items-center justify-center">
                      <i class="ri-camera-line text-white text-lg"></i>
                    </div>
                  </button>
                </div>
              </div>

              <!-- 右侧信息列 -->
              <div class="col-span-9">
                <h3 class="text-xl font-semibold text-gray-900 mb-4 mt-4">
                  {{ userInfo.nickname || userInfo.username || '未命名用户' }}
                </h3>
                <div class="space-y-3">

                  <div class="flex flex-col space-y-2">
                    <!-- 会员标志 -->
                    <div class="flex items-center text-gray-600 text-base">
                      <div class="w-5 h-5 flex items-center justify-center">
                        <i class="ri-user-line text-lg"></i>
                      </div>
                      <span>个人会员</span>
                      <div
                        class="w-5 h-5 flex items-center justify-center ml-4 text-yellow-600"
                        v-if="userInfo.distributor"
                      >
                        <i class="ri-vip-crown-line text-lg"></i>
                      </div>
                      <span class="text-yellow-600" v-if="userInfo.distributor">分销伙伴</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 一些数值统计 -->
            <div class="grid grid-cols-4 gap-4 mt-8">
              <div
                class="bg-white rounded-xl shadow-sm p-4 flex flex-col items-center"
              >
                <div class="text-3xl font-bold text-primary">
                  {{ userInfo.order_count || 0 }}
                </div>
                <div class="text-sm text-gray-600">已下订单</div>
              </div>
              <div
                class="bg-white rounded-xl shadow-sm p-4 flex flex-col items-center"
              >
                <div class="text-3xl font-bold text-primary">
                  {{ userInfo.payment_count || 0 }}
                </div>
                <div class="text-sm text-gray-600">已支付订单</div>
              </div>
              <div
                class="bg-white rounded-xl shadow-sm p-4 flex flex-col items-center"
              >
                <div class="text-3xl font-bold text-primary">
                  {{ userInfo.favorite_count || 0 }}
                </div>
                <div class="text-sm text-gray-600">收藏商品</div>
              </div>
              <!-- 一些数值 -->
              <div
                class="bg-white rounded-xl shadow-sm p-4 flex flex-col items-center"
              >
                <div class="text-3xl font-bold text-primary">
                  {{ userInfo.invoice_count || 0 }}
                </div>
                <div class="text-sm text-gray-600">发票管理</div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import api from "@/utils/api.js";
import { Message } from "element-ui";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import LeftNav from "@/components/LeftNav.vue";

export default {
  name: "UserCenter",
  components: {
    Nav,
    Footer,
    LeftNav,
  },
  data() {
    return {
      userInfo: {},
      userName: "",
      userEmail: "",
      userAvatar: "",
    };
  },
  mounted() {
    this.getBaseInfo();
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.back();
    },

    // 加载用户基础信息
    async getBaseInfo() {
      try {
        const response = await api.user.getBaseInfo();
        this.userInfo = response.data;
      } catch (error) {
        console.error("加载用户信息失败:", error);
      }
    },

    // 跳转到订单页面
    goToOrders() {
      Message.info("即将跳转到订单页面");
      // 实际项目中可以替换为真实的订单页面路由
      // this.$router.push('/ucenter/orders')
    },

    // 跳转到个人资料页面
    goToProfile() {
      Message.info("即将跳转到个人资料页面");
      // 实际项目中可以替换为真实的个人资料页面路由
      // this.$router.push('/ucenter/profile')
    },

    // 跳转到账号设置页面
    goToSettings() {
      Message.info("即将跳转到账号设置页面");
      // 实际项目中可以替换为真实的账号设置页面路由
      // this.$router.push('/ucenter/settings')
    },

    // 跳转到帮助中心
    goToHelp() {
      Message.info("即将跳转到帮助中心");
      // 实际项目中可以替换为真实的帮助中心页面路由
      // this.$router.push('/help')
    },

    // // 退出登录
    // async logout() {
    //   try {
    //     const response = await userLogout();
    //     if (response.code === 200) {
    //       Message.success("退出登录成功");
    //       setTimeout(() => {
    //         this.$router.push("/login");
    //       }, 1500);
    //     } else {
    //       Message.error("退出登录失败");
    //     }
    //   } catch (error) {
    //     console.error("退出登录失败:", error);
    //     Message.error("退出登录失败");
    //   }
    // },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/ucenter/Index.vue